import { WidgetInstance, getData } from '@livechat/widget-core';
import { apiConfig } from '@betty/toolkit/api';
import {
  appOpened,
  startListening,
  socketConnected,
} from '@betty/toolkit/state';
import { logInfo } from '@betty/toolkit/logging';
import { getAccount, setAccount } from '@betty/account/state';
import {
  groupUpdated,
  maximizeChat,
  setVisibility,
  selectGroupId,
  selectSessionFieldsTS,
  updateSessionVariables,
} from './chat.slice';
import { createChatWidget } from './chat.utils.web';
import {
  getSessionVariables,
  shouldSetSessionVariables,
} from './chat.utils.native';

export const WIDGET_LICENSE = '15246288';

let chatWidget: WidgetInstance;

startListening({
  actionCreator: appOpened,
  effect: () => {
    chatWidget = createChatWidget(WIDGET_LICENSE, undefined);
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on('LiveChatGroupIdUpdated', (data) => {
      logInfo('[GenericHub] LiveChatGroupIdUpdated', data);

      dispatch(
        setAccount({
          liveChatGroupId: data.groupId,
        }),
      );

      // Reinitialize the chat with the new group id.
      dispatch(groupUpdated());
    });
  },
});

startListening({
  actionCreator: groupUpdated,
  effect: (_, { getState }) => {
    const customerGroupId = selectGroupId(getState());
    const customerStatus = getData('customer').status;

    if (customerGroupId !== undefined && customerStatus !== 'chatting') {
      chatWidget.destroy();
      chatWidget = createChatWidget(WIDGET_LICENSE, customerGroupId);
    }
  },
});

startListening({
  actionCreator: setVisibility,
  effect: async ({ payload }, { dispatch, getState }) => {
    const userId = await apiConfig.getUserId();
    const sessionFieldsTS = selectSessionFieldsTS(getState());

    // There is no authenticated user.
    if (!userId || payload !== 'maximized') {
      return;
    }

    if (Number(userId) > 0 && shouldSetSessionVariables(sessionFieldsTS)) {
      dispatch(updateSessionVariables(getSessionVariables()));
    }
  },
});

startListening({
  actionCreator: maximizeChat,
  effect: () => {
    chatWidget.updateVisibility('maximized');
  },
});

const stopListening = startListening({
  actionCreator: getAccount.fulfilled,
  effect: ({ payload }, { dispatch }) => {
    const { liveChatGroupId } = payload;

    if (liveChatGroupId !== undefined) {
      dispatch(groupUpdated());
    }

    stopListening();
  },
});
